import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Table } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import Slider from "react-slick";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import Docmnt from '../../../assets/images/google-docs.png';
import Arcv from "../../../assets/images/archive.svg";
import Export from "../../../assets/images/export.svg";
import edit from "../../../assets/images/edit.png";
import Cargoplane from "../../../assets/images/plane.svg";
import Cuser from "../../../assets/images/cuser.png";
import Trash from '../../../assets/images/trash.png';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ImageUpload from '../../../Components/common/ImageUpload';
import ActivityComments from '../../../Components/common/ActivityComments';
import EditUld from './components/EditUld.js';
import Badge from 'react-bootstrap/Badge';
import Select from 'react-select';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { ULDOPERATIONGRID, GETDAMAGETYPE, UPDATECONDITION, GETULDDETAILS, MVTUPDATE, MVTHDETAILS, GETDESTINATION } from '../../../Utils/conts.js';
import Loader from '../../../Components/common/Loader.js';
import DownloadGrid from './components/DownloadGrid.js';
import { CallApi, jqxCookieCall } from '../../../Components/common/CommonFunctions.js';

const Operations = () => {
    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [disLoading, setDisLoading] = useState(false);
    const [gridData, setGridData] = useState([]);
    const [totalRows, setTotalRows] = useState({});
    const [damageType, setDamageType] = useState([]);
    const [responseAction, setResponseAction] = useState();
    const [filterApplied, setFilterApplied] = useState(false);
    const [inactiveCount, setInactiveCount] = useState(0);
    const [destination, setDestination] = useState([]);
    const [destHandler, setDestHandler] = useState([]);
    const [ghaData, setGhaData] = useState({});

    const fetchDataGrid = async (pageNumber, psize) => {
        try {
            // console.log("🚀 ~ fetchDataGrid ~ pageNumber:", pageNumber)
            const page_number = pageNumber ? pageNumber : 1;
            const pageSize = psize ? psize : 50;
            setIsLoading(true);
            const res = await withRFSToken.post(ULDOPERATIONGRID, { page: page_number, page_size: pageSize });
            // .then(function (res) {
            if (res.data.response_code == 200) {
                setIsLoading(false);
                const innerData = res.data.response_data.operationData;
                const innerDataCount = res.data.response_data.pagination;
                // console.log("🚀 ~ .then ~ innerData:654", innerData)
                // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'R' })) : '';
                setGridData(innerData);
                setTotalRows({
                    pageSize: innerDataCount.page_size,
                    currPage: innerDataCount.current_page,
                    lastPage: innerDataCount.last_page,
                    totalUlds: innerDataCount.total
                });
                // window.$(gridRef.current).jqxGrid('pagesize', innerDataCount.page_size);
            }
            // });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoading(false);
        }
    };
    const fetchDataInactive = async () => {
        try {
            const res = await withRFSToken.get('inactive/uld-list')
                .then(function (res) {
                    setInactiveCount(res?.data.TotalRows || 0);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            // setIsLoading(false);
        }
    };
    const fetchDestination = (stn) => {
        CallApi({
            endPoint: GETDESTINATION,
            onSuccess: (data) => {
                if (data.data.response_code === 200) {
                    const innerData = data.data.response_data
                    const trData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setDestination(trData)
                    const findHnd = trData.find(d => d.value === stn);
                    const rthndlr = findHnd.address.length ? findHnd.address.map(item => ({ value: item.id, label: item.company_name })) : [];
                    setDestHandler(rthndlr ?? []);
                    setGhaData({ destination_handler: gridSelect[0].destination_handler_id });
                    setDisLoading(false);
                    setShowConfirmation(true);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };

    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGrid();
        setIsLoading(false);
        setGridData([]);
        fetchDataInactive();
        isMounted.current = true;
    }, []);
    const fetchDamageType = async () => {
        try {
            const res = await withRFSToken.post(GETDAMAGETYPE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    console.log("🚀 ~ .then ~ innerData:650", innerData)
                    setDamageType(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    // const [activeTab, setActiveTab] = useState('Active');
    const gridRef = useRef(null);
    // Edit Uld
    const [showEdit, setShowEdit] = useState(false);
    const [editData, setEditData] = useState({});
    const [missingCount, setMissingCount] = useState(0);
    const handleCloseEditModal = () => {
        setShowEdit(false);
        setEditData({});
    };
    // Edit Uld
    const pageSize = totalRows.pageSize;
    const totalRowsCount = totalRows.totalUlds;
    const initCurrentPage = totalRows.currPage;
    // console.log('HHH', pageSize);
    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef.current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall()
            const source = {
                url: `${process.env.REACT_APP_RFS_URL}uld-control/operations`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'uld_id', type: 'string' },
                    { name: 'uld_number', type: 'string' },
                    { name: 'type_code', type: 'string' },
                    { name: 'serial_number', type: 'string' },
                    { name: 'owner_code', type: 'string' },
                    { name: 'condition_code', type: 'string' },
                    { name: 'condition', type: 'string' },
                    { name: 'content_code', type: 'string' },
                    { name: 'content', type: 'string' },
                    { name: 'status', type: 'string' },
                    { name: 'flight_or_truck', type: 'string' },
                    { name: 'flight_number', type: 'string' },
                    { name: 'flight_date', type: 'date' },
                    { name: 'origin', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'destination_handler', type: 'string' },
                    { name: 'scm', type: 'string' },
                    { name: 'scm_date', type: 'date' },
                    { name: 'on_loan', type: 'string' },
                    { name: 'luc_out', type: 'date' },
                    { name: 'luc_final_dest', type: 'string' },
                    { name: 'luc_in', type: 'date' },
                    { name: 'return_station', type: 'string' },
                    { name: 'asset_type', type: 'string' },
                    { name: 'damage_type', type: 'string' },
                    { name: 'damage_desc', type: 'string' },
                    { name: 'reg', type: 'string' },
                    { name: 'register', type: 'string' },
                    { name: 'origin_handler_id', type: 'string' },
                    { name: 'destination_handler_id', type: 'string' },
                    { name: 'received_by_name', type: 'string' },
                    { name: 'awb_number', type: 'string' },
                    { name: 'mvt_status', type: 'string' },

                    { name: 'flight_num', type: 'string' },
                    { name: 'flight_code', type: 'string' },
                    { name: 'equipment_expiry', type: 'string' },
                ],
                pagesize: 50,
                filter: function (allfilters) {
                    // window.$(gridRef.current).jqxGrid('clearselection');
                    // if (allfilters.length > 0) {
                    //     console.log("Filter Applied");
                    //     setFilterApplied(true);
                    // } else {
                    //     console.log("Filter Cleared");
                    //     setFilterApplied(false);
                    // }
                    // window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");

                    // setTimeout(() => {
                    //     const rows = window.$(gridRef.current).jqxGrid('getrows');

                    //     console.log("rows",rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);                            
                    //         rows.forEach((element,index) => {
                    //             if(element.uld_number==uldNumber){
                    //                 window.$(gridRef.current).jqxGrid('selectrow', index);
                    //             }
                    //         });                            
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    setMissingCount(data?.missingCount || 0);
                },
                sort: function (column, direction) {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
                    },
                    width: '4%', filterable: false,
                },
                { text: 'ULD Number', filtertype: 'textbox', datafield: 'uld_number', width: '7%', cellclassname: '', },
                { text: 'Type Code', filtertype: 'textbox', datafield: 'type_code', width: '5%', cellclassname: '', },
                { text: 'Serial Number', filtertype: 'textbox', datafield: 'serial_number', width: '6%', cellclassname: '', },
                { text: 'Owner Code', filtertype: 'textbox', datafield: 'owner_code', width: '5%', cellclassname: '', },
                // { text: 'Condition Code', filtertype: 'textbox', datafield: 'condition_code', width: '10%', cellclassname: '', },
                {
                    text: 'Condition Code', filtertype: 'checkedlist', filterable: true,
                    filteritems: [
                        { label: 'Serviceable', value: 'SER' },
                        { label: 'Damaged', value: 'DAM' },
                        { label: 'Discarded', value: 'DIS' }
                    ],
                    // cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                    //     if (rowdata.condition_code === 'SER') {
                    //         return '<div class="jqx-grid-cell-left-align set_dock ">Servicable</div>';
                    //     } else if (rowdata.condition_code === 'DAM') {
                    //         return '<div class="jqx-grid-cell-left-align set_dock">Damaged</div>';
                    //     } else {
                    //         return '<div class="jqx-grid-cell-left-align set_dock">Discarded</div>';
                    //     }
                    // },
                    datafield: 'condition', width: '7%', cellclassname: '',
                },
                // {
                //     text: 'Mismatch', filtertype: 'checkedlist', datafield: 'mvt_status', width: '7%', cellclassname: '',
                //     filteritems: [
                //         { label: 'Yes', value: 'yes' },
                //         { label: 'No', value: 'no' },
                //     ],

                //     cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                //         if (cellValue) {
                //             defaultHtml = "<div style='margin-left:18px;line-height: 38px;margin-top: 10px;'><span style='color: #d12828;font-weight:600;width:20px;height:20px;display: block;background: #fff;text-align: center;line-height: 17px;border: 2px solid #d12828;border-radius: 10px;font-size: 12px;'>! </span></div>";
                //         }
                //         return (
                //             defaultHtml
                //         );
                //     },
                // },
                {
                    text: 'Status', filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'In Operation', value: '1' },
                        { label: 'On Air', value: '4' },
                        { label: 'On Loan', value: '5' },
                        { label: 'Missing', value: '17' },
                        // { label: 'Repair', value: '2' },
                        // { label: 'In Reserve', value: '3' },

                    ],

                    datafield: 'status', width: '5%', cellclassname: '',
                },
                { text: 'Flight Number', filtertype: 'textbox', datafield: 'flight_number', width: '6%', cellclassname: '', },
                { text: 'Flight Date', filtertype: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'flight_date', width: '7%', cellclassname: '', },
                { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '4%', cellclassname: '', },
                { text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '5%', cellclassname: '', },

                { text: 'Handler Name', filtertype: 'textbox', datafield: 'destination_handler', width: '6%', cellclassname: '', },
                { text: 'Final Dest.', filtertype: 'textbox', datafield: 'luc_final_dest', width: '6%', cellclassname: '', },
                { text: 'Received By', filtertype: 'textbox', datafield: 'received_by_name', width: '6%', cellclassname: '', },
                {
                    text: 'On Loan', filtertype: 'textbox', datafield: 'on_loan', width: '5%',
                    cellclassname: (row, column, value) => {
                        // Extract the number of days from the on_loan string
                        const daysMatch = value.match(/(\d+)\s*day\(s\)/);
                        if (daysMatch) {
                            const days = parseInt(daysMatch[1], 10);
                            if (days === 0) {
                                return ''; // No class if the value is 0
                            } else if (days >= 10) {
                                return 'lucinred';
                            } else if (days >= 7) {
                                return 'lucinorange';
                            }
                        }
                        return ''; // Default class if format is unexpected
                    }
                },
                { text: 'LUC Out', filtertype: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'luc_out', width: '6%', cellclassname: '', },

                { text: 'LUC In', filtertype: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'luc_in', width: '6%', cellclassname: '', },
                { text: 'Return Station', filtertype: 'textbox', datafield: 'return_station', width: '6%', cellclassname: '', },
                { text: 'SCM', filtertype: 'textbox', datafield: 'scm', width: '3%', cellclassname: '', },
                { text: 'SCM Date', filtertype: 'range', datafield: 'scm_date', cellsformat: 'dd-MM-yyyy', width: '5%', cellclassname: '', },
                { text: 'Airway Bill', filtertype: 'textbox', datafield: 'awb_number', width: '7%', cellclassname: '', },
                { text: 'Equipment Expiry', filtertype: 'textbox', datafield: 'equipment_expiry', width: '7%', cellclassname: '', },
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: pageSize,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRef.current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRef.current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.uld_number;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.uld_number === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.uld_number;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('Row Data:', rowData);
                        const dataToSend = {
                            uld_number: rowData.uld_number,
                            awb_number: rowData.awb_number,
                            type_code: rowData.type_code,
                            serial_number: rowData.serial_number,
                            owner_code: rowData.owner_code,
                            condition_code: rowData.condition_code,
                            // asset_type: rowData.asset_type,
                            destination: rowData.destination,
                            handler_name_id: rowData.destination_handler_id,
                            flight_code: rowData.flight_code,
                            flight_num: rowData.flight_num,
                            flight_date: new Date(rowData.flight_date).toISOString().split('T')[0],
                            asset_type: rowData.asset_type == 'Y' ? false : true
                        };
                        setEditData(dataToSend);
                        setShowEdit(true);
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
                // const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);


            });
            window.$(gridRef.current).off('cellclick');
            window.$(gridRef.current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {

                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        // setGridSelect([]);
                    }
                    loadDetails(args.uld_number);
                }
            });
        }
    }, [gridData]);

    const loadDetails = async (uldNumber) => {
        setDisLoading(true)
        try {
            const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    setSelectedRowData(innerData);
                    setTimeout(() => {
                        window.$(gridRef.current).jqxGrid('refresh');
                    }, 30);
                    setDisLoading(false)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleCloseClick = () => {
        setSelectedRowData(null);
        setTimeout(() => {
            window.$(gridRef.current).jqxGrid('refresh');
        }, 30);
    };

    const [downloadOpen, setDownloadOpen] = useState(false);
    const showDownloadModal = () => {
        setDownloadOpen(true);
    };
    const closeDownloadModal = () => {
        setDownloadOpen(false);
    };
    const fetchDataGridFilter = async (pageNumber, psize) => {
        try {
            // console.log("🚀 ~ fetchDataGrid ~ pageNumber:", pageNumber)
            const page_number = pageNumber ? pageNumber : 1;
            const pageSize = psize ? psize : 20;
            const res = await withRFSToken.post(ULDOPERATIONGRID, { page: page_number, page_size: pageSize });
            // .then(function (res) {
            if (res.data.response_code == 200) {
                const innerData = res.data.response_data.operationData;
                const innerDataCount = res.data.response_data.pagination;
                // console.log("🚀 ~ .then ~ innerData:654", innerData)
                // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'R' })) : '';
                setGridData(innerData);
                setTotalRows({
                    pageSize: innerDataCount.page_size,
                    currPage: innerDataCount.current_page,
                    lastPage: innerDataCount.last_page,
                    totalUlds: innerDataCount.total
                });
                // window.$(gridRef.current).jqxGrid('pagesize', innerDataCount.page_size);
            }
            // });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    // const columnsToExport = {
    //     // uld_number: 'ULD Number',
    //     type_code: 'Type Code',
    //     // serial_number: 'Serial Number',
    //     owner_code: 'Owner Code',
    //     condition_code: 'Condition Code',
    //     status: 'Status',
    //     origin: 'Origin',
    //     destination: 'Destination',
    //     // scm: 'SCM',
    //     // scm_date: 'SCM Date',
    //     // asset_type: 'Asset Type',
    //     // handler_name: 'Handler Name',
    //     // airline_name: 'Airline Name',
    //     // Add more columns here if needed
    // };
    // const handleColumnChange = (columnKey) => {
    //     setSelectedColumns(prevSelected =>
    //         prevSelected.includes(columnKey)
    //             ? prevSelected.filter(key => key !== columnKey)
    //             : [...prevSelected, columnKey]
    //     );
    // };
    // const exportToExcel = async () => {

    //     // try {
    //     //     const res = await withRFSToken.post(DOWNLOADULD, { tab_name: activeTab, fields: selectedColumns })
    //     //         .then(function (res) {
    //     //             const innerData = res.data.response_data.ulds;
    //     //             console.log("🚀 ~ .then ~ innerData:987", innerData)
    //     //             // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'R' })) : '';
    //     //             // setGridData({ Active: innerData });
    //     //             // setTotalRecords(res.data.response_data.total_ulds);
    //     //         });


    //     // } catch (error) {
    //     //     console.error('Error fetching data:', error);
    //     // }
    //     if (gridRef.current) {
    //         const excelData = window.$(gridRef.current).jqxGrid('getrows');

    //         // Filter and transform the grid data to include only the specified columns with desired names
    //         const filteredData = excelData.map(row => {
    //             const filteredRow = {};
    //             // Object.keys(columnsToExport).forEach(key => {
    //             //     filteredRow[columnsToExport[key]] = row[key];
    //             // });
    //             selectedColumns.forEach(key => {
    //                 filteredRow[columnsToExport[key]] = row[key];
    //             });
    //             return filteredRow;
    //         });
    //         const worksheet = XLSX.utils.json_to_sheet(filteredData);

    //         // Create a new workbook and append the worksheet
    //         const workbook = XLSX.utils.book_new();
    //         XLSX.utils.book_append_sheet(workbook, worksheet, 'GridData');

    //         // Write the workbook to a file and trigger a download
    //         XLSX.writeFile(workbook, 'GridData.xlsx');
    //         setSelectedColumns([]);
    //         setModalOpen(false);
    //     }
    // };


    // ++++++++++++++++++++++++++++++++++++++++++++ HTML EDITOR

    var settings = {
        dots: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,

    };

    // +++++++++++++++++++++++++++++++++++ Silk Slider

    const [show, setShow] = useState(false);
    const [selectedFile, setSelectedFile] = useState('');

    const handleFileClick = (file) => {
        setSelectedFile(file);
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setSelectedFile('');
    };

    // ++++++++++++++++++++++++++++++++++++ Zoom Image


    const [showConfirmation, setShowConfirmation] = useState(false);
    const [changeFunction, setchangeFunction] = useState(null);
    const [action, setAction] = useState(null);

    const handleFieldChange = (id, fieldName, event) => {
        const { value, files } = event.target;

        setGridSelect(prevFormData =>
            prevFormData.map(stack => {
                if (stack.uid === id) {
                    const updatedStack = { ...stack, [fieldName]: value };
                    return updatedStack;
                }
                return stack;
            })
        );
    };

    const handleDropdownItemClick = async (pos, action) => {
        const keysToRemove = [
            'Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out',
            'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'
        ];

        // Remove keys from localStorage
        keysToRemove.forEach(key => localStorage.removeItem(key));

        // Helper function to save data and navigate to the given URL
        const saveAndNavigate = (action, data, url = '/ULDControl/ULDFunction') => {
            localStorage.setItem(action, JSON.stringify(data));
            localStorage.setItem('tab', 'operations');
            window.location.href = url;
        };

        // Helper function to create storage data for ULD
        const createStorageData = (ULDData, additionalForm = {}) => {
            const form = {
                flight_or_truck: ULDData.flight_or_truck === 'Flight' ? 'F' : 'T',
                flight_number: ULDData.flight_number,
                flight_date: ULDData.flight_date,
                origin: ULDData.origin,
                destination: ULDData.destination,
                ...additionalForm
            };
            return { ULD: [ULDData], Form: form };
        };

        // Handle operations for 'details' position
        const handleDetails = async () => {
            if (['Repair In', 'Repair Out', 'SCM', 'UCM Out', 'LUC In', 'LUC Out'].includes(action)) {
                const storageData = createStorageData(selectedRowData);
                saveAndNavigate(action, storageData);
            } else if (action === 'Lease Out') {
                if (selectedRowData.asset_type === 'Y') {
                    toast.error("ULDs with Asset Type Owned cannot go for Lease Out");
                } else {
                    const storageData = createStorageData(selectedRowData);
                    saveAndNavigate(action, storageData);
                }
            } else if (action === 'UCM In') {
                await handleUCMInAction(selectedRowData.uld_number);
            } else {
                setAction(action);
                setShowConfirmation(true);
                setchangeFunction(() => changeStatus);
            }
        };

        // Handle UCM In action with API call
        const handleUCMInAction = async (uldNumbers) => {
            try {
                const response = await withRFSToken.post(MVTUPDATE, { action_type: 'UI', ulds: uldNumbers });
                const { response_code, response_data } = response.data;
                if (response_code === 200) {
                    if (response_data.logic_type === 1) {
                        const storageData = {
                            ULD: response_data.ulds,
                            Form: response_data.Form
                        };
                        saveAndNavigate('UCM In', storageData);
                    } else {
                        setResponseAction(response_data);
                        setShowConfirmation(true);
                    }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        // Handle operations for 'top' position
        const handleTop = async () => {
            if (gridSelect.length === 0) {
                if (['Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM In', 'UCM Out', 'LUC In', 'LUC Out'].includes(action)) {
                    const storageData = { ULD: [], Form: {} };
                    saveAndNavigate(action, storageData);
                } else {
                    toast.error('Please select at least one stock to operate.');
                }
            } else {
                if (['Repair In', 'Repair Out', 'SCM', 'LUC In', 'LUC Out'].includes(action)) {
                    const storageData = { ULD: gridSelect, Form: {} };
                    saveAndNavigate(action, storageData);
                } else if (action === 'Lease Out') {
                    const hasOwnedAssetType = gridSelect.some(item => item.asset_type === 'Y');
                    if (hasOwnedAssetType) {
                        toast.error("ULDs with asset type Owned selected, this action is not possible.");
                    } else {
                        const storageData = { ULD: gridSelect, Form: {} };
                        saveAndNavigate(action, storageData);
                    }
                } else if (action === 'UCM Out') {
                    // const flightData = gridSelect.flight_number;
                    // const [flight, flightNumber] = flightData.split('-') || ['', ''];
                    // const updateFormData = {
                    //     flight_or_truck: gridSelect.flight_or_truck || '',
                    //     flight_code: flight || '',
                    //     flight_number: flightNumber,
                    //     flight_date: gridSelect.flight_date || '',
                    //     origin: gridSelect.origin || '',
                    //     origin_handler: gridSelect.origin_handler || '',
                    //     destination: gridSelect.destination || '',
                    //     destination_handler: gridSelect.destination_handler || '',
                    //     flight_reg_number: gridSelect.flight_reg_number || ''
                    // }

                    // const updateData = gridSelect?.map((grd, index) => ({...grd, rowId: index + 1}))
                    const storageData = { ULD: gridSelect, Form: {} };
                    saveAndNavigate(action, storageData);
                } else if (action === 'UCM In') {
                    await handleUCMInAction(gridSelect.map(item => item.uld_number));
                } else {
                    if (gridSelect.some(item => item.status === action)) {
                        toast.error(`Status already ${action}`);
                    } else {
                        setAction(action);

                        if (action === 'Condition') { fetchDamageType(); setShowConfirmation(true); }
                        else if (action === 'GHA') {
                            setDisLoading(true);
                            const chkDest = gridSelect.every(item => item.destination === gridSelect[0].destination);
                            console.log('chkDest', chkDest);

                            const chkDestH = gridSelect.every(item => item.destination_handler_id === gridSelect[0].destination_handler_id);
                            if (!chkDest) { toast.error('GHA Transfer can only be executed for ULDs with the same current destination'); setDisLoading(false); return; }
                            if (!chkDestH) { toast.error('GHA Transfer can only be executed for ULDs with the same current handler'); setDisLoading(false); return; }
                            if (chkDest && chkDestH) {
                                fetchDestination(gridSelect[0].destination)
                            }
                        } else {
                            setchangeFunction(() => changeStatus);
                            setShowConfirmation(true);
                        }
                    }
                }
            }
        };

        // Main conditional logic based on position
        if (pos === 'details') {
            await handleDetails();
        } else if (pos === 'top') {
            await handleTop();
        }
    };

    const changeStatus = async (selectedIds) => {
        // console.log("🚀 ~ deleteSelectedRows ~ selectedIds:", selectedIds)

        // deleteRow(gridSelect);
        changeFunction(gridSelect)
        setShowConfirmation(false);


        //console.log("🚀 ~ changeStatus ~ uniqueIds:", uniqueIds)
        // console.log("🚀 ~ changeStatus ~ uniqueIds:", uniqueIds)
        // try {
        //   const res = await withToken.post(TRASH_ROW_IDS, {booking_ids: uniqueIds});
        //   console.log("responsehg==>", res);
        //   window.$(gridRef.current).jqxGrid('unselectrow', selectedIds);
        //   const updategrid = window.$(gridRef.current).jqxGrid();
        //   // setupGrid();
        //   reloadGrid();
        //   setGridSelect([]);
        //   window.$(gridRef.current).jqxGrid('clearselection');

        //   // setTimeout(() => {
        //   //    window.location.replace('/')  
        //   // },1000);

        // } catch (error) {
        //   console.error('Error sending request:', error);
        // }
    };

    const [conditionChange, setConditionChange] = useState('Serviceable');

    const handleConditionRadioChange = (e) => {
        setConditionChange(e.target.value);
    };
    const handleConfirmChange = async (actionType) => {
        // deleteRow(gridSelect);
        // selectedRowData ? selectedRowData.uld_number : gridSelect.map(item => item.uld_number)
        const conditionType = conditionChange && conditionChange == 'Serviceable' ? 'SER' : (conditionChange == 'Damage' ? 'DAM' : 'DIS')
        if (conditionChange == 'Serviceable') {
            const uldNumbers = gridSelect && gridSelect.map(item => ({ code: item.uld_number }));
            try {
                const res = await withRFSToken.post(UPDATECONDITION, { uld_codes: uldNumbers, condition_type: conditionType });
                if (res.data.response_code == 200) {
                    toast.success('Condition Updated');
                    fetchDataGrid();
                    setShowConfirmation(false);
                    // unselect Grid
                    gridSelect.forEach(item => {
                        const selectedRowBoundIndex = item.boundindex;
                        window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                    });
                    setGridSelect([]);
                    //   Grid unselect and blank variable End
                    // changeFunction(gridSelect)
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            const uldDam = gridSelect.map(item => ({ code: item.uld_number, damage_type: item.damage_type, desc: item.desc, files: item.base64Files }));
            // console.log("🚀 ~ handleConfirmChange ~ uldDam:", uldDam)
            try {
                const res = await withRFSToken.post(UPDATECONDITION, { uld_codes: uldDam, condition_type: conditionType });
                if (res.data.response_code == 200) {
                    toast.success('Condition Updated');
                    fetchDataGrid();
                    setShowConfirmation(false);
                    // unselect Grid
                    gridSelect.forEach(item => {
                        const selectedRowBoundIndex = item.boundindex;
                        window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                    });
                    setGridSelect([]);
                    setFiles([]);
                    setBase64Files([]);
                    if (selectedRowData) {
                        loadDetails(selectedRowData.uld_number)
                    }
                    //   Grid unselect and blank variable End
                    // changeFunction(gridSelect)

                } else { toast.error(res.data.response_msg) }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        // changeFunction(gridSelect)
        // setShowConfirmation(false);
    };
    const handleActionConfirm = (logicType) => {
        if (logicType == 2) {
            const storageData = {
                "ULD": responseAction.ulds,  // ULD Details section
                "Form": {}  // Empty form section
            };
            localStorage.setItem('UCM In', JSON.stringify(storageData));
            localStorage.setItem('tab', 'operations');
            const fnPageUrl = '/ULDControl/ULDFunction'
            window.location.href = fnPageUrl;
        } else if (logicType == 3) {
            const storageData = {
                "ULD": responseAction.ulds,  // ULD Details section
                "Form": responseAction.Form  // Empty form section
            };
            localStorage.setItem('UCM In', JSON.stringify(storageData));
            localStorage.setItem('tab', 'operations');
            const fnPageUrl = '/ULDControl/ULDFunction'
            window.location.href = fnPageUrl;
        } else if (logicType == 4) {
            const storageData = {
                "ULD": responseAction.ulds,  // ULD Details section
                "Form": {}  // Empty form section
            };
            localStorage.setItem('UCM In', JSON.stringify(storageData));
            localStorage.setItem('tab', 'operations');
            const fnPageUrl = '/ULDControl/ULDFunction'
            window.location.href = fnPageUrl;
        } else if (logicType == 5) {
            const storageData = {
                "ULD": responseAction.ulds,  // ULD Details section
                "Form": responseAction.Form  // Empty form section
            };
            localStorage.setItem('UCM In', JSON.stringify(storageData));
            localStorage.setItem('tab', 'operations');
            const fnPageUrl = '/ULDControl/ULDFunction'
            window.location.href = fnPageUrl;
        } else if (logicType == 6) {
            const storageData = {
                "ULD": responseAction.ulds,  // ULD Details section
                "Form": responseAction.Form  // Empty form section
            };
            localStorage.setItem('UCM In', JSON.stringify(storageData));
            localStorage.setItem('tab', 'operations');
            const fnPageUrl = '/ULDControl/ULDFunction'
            window.location.href = fnPageUrl;
        }
    }
    const handleActionNoConfirm = (logicType) => {
        if (logicType == 2) {
            setShowConfirmation(false);
        } else if (logicType == 3) {
            setShowConfirmation(false);
        } else if (logicType == 4) {
            setShowConfirmation(false);
        } else if (logicType == 5) {
            setShowConfirmation(false);
        } else if (logicType == 6) {
            if (gridSelect) {
                const flightData = gridSelect.flight_number;
                const [flight, flightNumber] = flightData ? flightData.split('-') : ['', ''];
                const flight_date = gridSelect.flight_date ? new Date(gridSelect.flight_date).toISOString().split('T')[0] : '';
                const form_data = {
                    flight_or_truck: gridSelect.flight_or_truck || '',
                    flight: flight || '',           // Set the flight code
                    flight_number: flightNumber || '', // Set the flight number
                    flight_date: flight_date || '',
                    origin: gridSelect.origin || '',
                    origin_handler: gridSelect.origin_handler_id || '',
                    destination: gridSelect.destination || '',
                    destination_handler: gridSelect.destination_handler_id || '',
                }
                const storageData = {
                    "ULD": gridSelect,  // ULD Details section
                    // "Form": gridSelect.length > 0 ? gridSelect[0] : {}  // Empty form section
                    "Form": responseAction.Form  // Empty form section
                };
                localStorage.setItem('UCM In', JSON.stringify(storageData));
                localStorage.setItem('tab', 'operations');
                const fnPageUrl = '/ULDControl/ULDFunction'
                window.location.href = fnPageUrl;
            }

        }

    }

    const handleRemove = (indexToRemove) => {
        // const idToRemove = gridSelect[indexToRemove];
        // const selectedRowBoundIndex = idToRemove.boundindex;
        // window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
        // // setGridSelect(prevGridSelect => prevGridSelect.filter((_, index) => index !== indexToRemove));
        // const newGridSelect = [...gridSelect.slice(0, indexToRemove), ...gridSelect.slice(indexToRemove + 1)];
        // setGridSelect(newGridSelect);
        const rows = window.$(gridRef.current).jqxGrid('getrows');
        rows.forEach((element, index) => {
            if (element.uld_number == indexToRemove) {
                window.$(gridRef.current).jqxGrid('unselectrow', index);
            }
        });
    };

    const processGHA = () => {
        const uldIds = gridSelect.map(dt => dt.uld_id)
        // console.log('gridSelect', gridSelect);
        // console.log('uldIds', uldIds);

        CallApi({
            endPoint: 'uld-action/gha-transfer',
            payload: { ...ghaData, uld_ids: uldIds, origin_handler: gridSelect[0]?.destination_handler_id, },
            onSuccess: (data) => {
                if (data.data.response_code === 200) {
                    updateGrid();
                    setShowConfirmation(false);
                    toast.success(data.data.response_msg)
                    gridSelect.forEach(item => {
                        const selectedRowBoundIndex = item.boundindex;
                        window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                    });
                    setGridSelect([]);
                } else {
                    toast.error(data.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    // upload Section
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);

    // const imageModalUpload = (id) => {
    //     setSelectedRowId(id);
    //     setShowModalUpload(true)
    //     setFiles([])
    // }
    const conditionModalClose = () => {
        setShowConfirmation(false);
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => ({
                ...item,
                files: [],
                base64Files: []
            }))
        );
        setFiles([])
        setBase64Files([]);
    }
    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                // filesWithBase64.push({ file, base64: reader.result });
                filesWithBase64.push({ "base64": reader.result, "file_name": file.name });
                if (filesWithBase64.length === selectedFiles.length) {
                    // setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);
                    // setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => obj.base64)]);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };

    const movementHistoryClick = () => {
        localStorage.removeItem('MHistory');
        const storageData = {
            ULD: selectedRowData,  // ULD Details section
            Form: {}  // Empty form section
        };
        localStorage.setItem('MHistory', JSON.stringify(storageData));
        // localStorage.setItem('tab', 'operations');
        window.location.href = '/ULDControl/MovementHistory'
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    // History Details
    const handleDetailsClick = async (history) => {
        console.log("🚀 ~ handleDetailsClick ~ history:", history)

        if (!selectedRowData) {
            throw new Error('Selected row data is not available.');
        }

        try {
            const res = await withRFSToken.post(MVTHDETAILS, { uld_id: selectedRowData.uld_id, uld_status_id: history.uld_status_id, group_id: history.group_id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    localStorage.removeItem('MHistory');
                    localStorage.removeItem('MHDetails');
                    const storageData = {
                        ULD: selectedRowData,  // ULD Details section
                        Form: {}  // Empty form section
                    };
                    localStorage.setItem('MHistory', JSON.stringify(storageData));
                    const storageDataDetails = {
                        ULD: innerData.others_ulds,  // ULD Details section
                        Form: innerData.uld_movement_detail,
                        tab: 'All'  // Empty form section
                    };
                    localStorage.setItem('MHDetails', JSON.stringify(storageDataDetails));
                    // localStorage.setItem('tab', 'operations');
                    let detailsPageUrl;
                    const detailsType = history.operation_type || history.ucm_inout || history.luc_inout || history.repair_inout || history.lease_inout || history.station;
                    if (detailsType) {

                        detailsPageUrl = '/ULDControl/MovementHistorydetails';
                        window.location.href = detailsPageUrl;
                    } else {
                        console.log('No valid details type found');
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const resetFilters = () => {
        window.$(gridRef.current).jqxGrid('clearfilters');
    };
    const goRecovery = (src) => {
        if (src == 'missing') {
            localStorage.setItem('Rtab', 'missing');
            window.location.href = '/Recovery'
        } else if (src == 'inactive') {
            localStorage.setItem('Rtab', 'inactive');
            window.location.href = '/Recovery'
        }
    }
    const updateGrid = () => {
        setTimeout(() => {
            window.$(gridRef.current).jqxGrid('updatebounddata');
        }, 1);
    }

    return (
        <>
            {/* {console.log('gridSelect', gridSelect)} */}
            {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            {showEdit && <EditUld edit_data={editData} reloadEdit={fetchDataGrid} onClose={handleCloseEditModal} />}
            {downloadOpen && <DownloadGrid download_sec='operations' onClose={closeDownloadModal} />}
            <div className="mb-3 nestedtabs rounded minh">
                <div className='d-flex'>
                    <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
                            <FontAwesomeIcon icon={faPlus} /> Add ULD <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item href="/ULDControl/AddStock">New Stock</Dropdown.Item>
                            {/* <Dropdown.Item href="/ULDControl/NewCharter">New Charter</Dropdown.Item> */}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='action acmvt'>
                            <FontAwesomeIcon icon={faGear} /> MVT <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'UCM Out')}>UCM Out</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'UCM In')}>UCM In</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'LUC Out')}>LUC Out</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'LUC In')}>LUC In</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Repair In')}>Repair In</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Repair Out')}>Repair Out</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Lease Out')}>Lease Out</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'SCM')}>SCM</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'GHA')}>GHA Transfer</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <button className="condition" variant="link" onClick={() => handleDropdownItemClick('top', 'Condition')}>
                        <span> <FontAwesomeIcon icon={faCircleCheck} /> Condition</span>
                    </button>
                    <button className="selected" variant="link" onClick={() => void (0)}>
                        Selected ULD <Badge>{gridSelect.length}</Badge>
                    </button>
                    <button className="selected" variant="link" onClick={() => goRecovery('missing')}>
                        Missing ULD <Badge className='bg_missing' >{missingCount}</Badge>
                    </button>
                    <button className="selected" variant="link" onClick={() => goRecovery('inactive')}>
                        Inactive ULD <Badge className='bg_inactive'>{inactiveCount}</Badge>
                    </button>
                </div>
            </div>
            <div className='ulddown'>
                <button onClick={showDownloadModal}><img src={Export} /> Download</button>
            </div>

            <div className="maindiv mt-4">
                <div className='trashdonload posr'>
                    {/* <Loader isLoading={isLoading} /> */}
                    {filterApplied ? <><div className='clear_filter notab'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                    {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
                </div>
                {selectedRowData && (
                    <div className='SecondDiv'>
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.uld_number} &nbsp; <span>{selectedRowData.status}</span>
                            </h3>
                            <div className='d-flex actbtn'>

                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic">
                                        <FontAwesomeIcon icon={faGear} /> MVT <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'UCM Out')}>UCM Out</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'UCM In')}>UCM In</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'LUC Out')}>LUC Out</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'LUC In')}>LUC In</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Repair In')}>Repair In</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Repair Out')}>Repair In</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Lease Out')}>Lease Out</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'SCM')}>SCM</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                            </div>

                        </div>
                        <div className='d-flex justify-content-between rabord'>
                            <div className='firstbrd'>
                                <p>Origin</p>
                                <span>{selectedRowData.origin}</span>
                            </div>
                            <div className='middlebrd'>
                                <p>{selectedRowData.flight_date}</p>
                                <p><img src={Cargoplane} /></p>
                                <p>{selectedRowData.flight_number}</p>
                            </div>
                            <div className='lastbrd'>
                                <p>Destination</p>
                                <span>{selectedRowData.destination}</span>
                            </div>
                        </div>
                        <div className='movment_history'>
                            <h3>Movement History</h3> <Link to='#' onClick={movementHistoryClick}>View All</Link>
                        </div>
                        <div className='movment_list'>
                            <ul>
                                {selectedRowData && selectedRowData.movement_history.slice(0, 5).map((history, index) => (
                                    <li key={index}>
                                        <span className='movem'>{history.operation_type}</span>
                                        <span className='mvdate'>{history.operation_date}</span>
                                        <Link to='#' onClick={() => handleDetailsClick(history)}>Details</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {/* {selectedRowData && selectedRowData.operational_trucks.map((truck) => (
                                <div key={truck.truck_id} className='d-flex justify-content-between align-items-center opt_truck'>
                                    {console.log("🚀 ~ ExportActive ~ truck:", truck)}
                                    <div>
                                        <span>Truck No</span>
                                        <h4>{truck.truck_no}</h4>
                                    </div>
                                    <div className={truck.request_status == 'O' ? 'offer_reecv' : (truck.request_status == 'B' ? 'booked' : 'offer_rqst')}>
                                        <span>{truck.request_status == 'O' ? 'Offer Received' : (truck.request_status == 'B' ? 'Booked' : 'Requested')}</span>
                                    </div>
                                    <div>
                                        <Link>Details</Link>
                                    </div>
                                </div>
                            ))} */}
                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"uld"}
                            attachable_id={selectedRowData.uld_number}
                            attachments={selectedRowData.attachments}
                            onDeleteSuccess={() => loadDetails(selectedRowData.uld_number)}
                        />
                        <ActivityComments
                            commentable_type={"uld"}
                            commentable_id={selectedRowData.uld_number}
                            allactivities={selectedRowData.activities}
                            onReloadDetails={loadDetails}
                        />
                    </div>
                )}
            </div>
            {/* <Modal show={isModalOpen} onHide={() => setModalOpen(false)} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Download Columns</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='downloadmd'>
                        {Object.keys(columnsToExport).map(columnKey => (
                            <label key={columnKey}>
                                <input
                                    type="checkbox"
                                    checked={selectedColumns.includes(columnKey)}
                                    onChange={() => handleColumnChange(columnKey)}
                                /> &nbsp;
                                {columnsToExport[columnKey]}
                            </label>
                        ))}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="primary" onClick={exportToExcel}>
                            Export
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal> */}
            <Modal show={showModalUpload} onHide={() => setShowModalUpload(false)} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <div className='type_work'>

                        <div className='ra_condition'>
                            <div
                                className='dropfile'
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                            >
                                <h3>Drag and drop files here</h3>
                                <p>Or</p>
                                <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                                <span>Maximum file size 4 MB</span>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                    multiple
                                />
                            </div>
                            <div className='uploadbox'>
                                {files.map((file, index) => (
                                    <div key={index} className='uploadfil'>
                                        {file.base64.includes('image') ? (
                                            <img
                                                src={file.base64}
                                                alt="Preview"
                                                style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                            />
                                        ) : (
                                            <span className='d-flex'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                                        )}
                                        <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="primary" onClick={imageUpload}>
                            Upload
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal className={action === 'Condition' || action === 'GHA' ? 'addfrom in_oparation' : 'addfrom change_type'} show={showConfirmation} onHide={() => conditionModalClose()} centered size={action === 'Condition' || action === 'GHA' ? 'lg' : 'md'}>
                <Modal.Header closeButton>
                    {action === 'Condition' ? (
                        <>
                            <Modal.Title>{action}</Modal.Title>
                            <p>Select Condition by selecting the option.</p>
                        </>
                    ) : action === 'GHA' ?
                        <>
                            <Modal.Title>{action} Transfer - {gridSelect[0]?.destination}</Modal.Title>
                            <p>Transfer selected ULDs between two handlers at airport.</p>
                        </>
                        : ''
                    }
                    {/* {['Repair', 'Lease Out', 'Condition'].includes(action) ? action : null} */}
                </Modal.Header>
                <Modal.Body>
                    {action == 'Condition' ?
                        (
                            <>
                                <Form.Group controlId="dropdown" className='mb-3 ck_condition'>
                                    <Form.Check
                                        label="Serviceable"
                                        name="condition_type"
                                        type='radio'
                                        id='Serviceable'
                                        value="Serviceable"
                                        checked={conditionChange === 'Serviceable'}
                                        onChange={handleConditionRadioChange}
                                    />
                                    <Form.Check
                                        label="Damaged"
                                        name="condition_type"
                                        type='radio'
                                        id='Damage'
                                        value="Damage"
                                        checked={conditionChange === 'Damage'}
                                        onChange={handleConditionRadioChange}
                                    />
                                    <Form.Check
                                        label="Discarded"
                                        name="condition_type"
                                        type='radio'
                                        id='Discarded'
                                        value="Discarded"
                                        checked={conditionChange === 'Discarded'}
                                        onChange={handleConditionRadioChange}
                                    />
                                </Form.Group>

                                <div className={conditionChange == 'Serviceable' ? 'd-flex flex-row bd-highlight inop serv_width' : 'd-flex flex-column bd-highlight inop'}>
                                    {gridSelect && gridSelect.map((num, index) => (
                                        <>
                                            {conditionChange == 'Serviceable' ? (
                                                <div key={index} className='inbox d-flex justify-content-between align-items-center'>
                                                    <span>{num.uld_number}</span>

                                                    <div><img src={Trash} alt='' onClick={() => handleRemove(num.uld_number)} /></div>
                                                </div>
                                            ) : (conditionChange == 'Damage' ? (
                                                <div key={index} className='inbox d-flex justify-content-between align-items-center damage_w'>
                                                    <div><span>{num.uld_number}</span></div>
                                                    <div>
                                                        {/* <Form.Select name='damage_type' id={num.uid} onChange={(event) => handleFieldChange(num.uid, 'damage_type', event)}>
                                                            <option>Damag Type</option>
                                                            {damageType &&
                                                                Object.entries(damageType).map((option, index) =>
                                                                    <option key={index} value={option[0]}>{option[0]} - {option[1]}</option>
                                                                )
                                                            }
                                                        </Form.Select> */}
                                                        <Select
                                                            options={damageType}
                                                            onChange={(selected) => {
                                                                const updatedData = gridSelect.map(item => {
                                                                    if (item.uid === num.uid) {
                                                                        return { ...item, damage_type: selected.value };
                                                                    }
                                                                    return item;
                                                                });
                                                                setGridSelect(updatedData);
                                                            }}
                                                            placeholder="Damage Type"
                                                            className='autoslct'
                                                            name="damage_type"
                                                        // value={damageType.find(option => option.value === num.damage_type)}
                                                        />
                                                    </div>
                                                    <div>
                                                        <Form.Control type="text" placeholder="Damage Description" name='desc' onChange={(event) => handleFieldChange(num.uid, 'desc', event)} />
                                                    </div>
                                                    <div>
                                                        <Button variant="outline-primary" className='upfile' onClick={() => imageModalUpload(num.uid)}>Upload file {num.files && num.files.length > 0 ? num.files.length : ''}</Button>
                                                    </div>
                                                    <div><img src={Trash} alt='' onClick={() => handleRemove(num.uld_number)} /></div>
                                                </div>
                                            ) : (
                                                <div key={index} className='inbox d-flex justify-content-between align-items-center damage_w'>
                                                    <div><span>{num.uld_number}</span></div>
                                                    <div><Form.Control type="email" placeholder="Discarded Description" className='dis_des' name='desc' onChange={(event) => handleFieldChange(num.uid, 'desc', event)} /></div>
                                                    <div><Button variant="outline-primary" className='upfile' onClick={() => imageModalUpload(num.uid)}>Upload file {num.files && num.files.length > 0 ? num.files.length : ''}</Button></div>
                                                    <div><img src={Trash} alt='' onClick={() => handleRemove(num.uld_number)} /></div>
                                                </div>
                                            ))}

                                        </>
                                    ))}
                                </div>

                            </>
                        ) : action == 'GHA' ?
                            <>
                                <Form.Group controlId="dropdown" className='mb-3 ck_condition inop'>
                                    <Form.Label>Transfer Date/Time <span>*</span></Form.Label>
                                    <Form.Control
                                        type="datetime-local"
                                        name="transfer_date"
                                        className='autoslct'
                                        value={ghaData.transfer_date || ''}
                                        onChange={(e) => setGhaData({ ...ghaData, transfer_date: e.target.value })}
                                    />
                                </Form.Group>
                                <Form.Group controlId="dropdown" className='mb-3 ck_condition d-flex'>
                                    <div>
                                        <Form.Label>Handler Name</Form.Label>
                                        <Select
                                            options={destHandler}
                                            onChange={(selected) => {

                                            }}
                                            placeholder="Destination"
                                            className='autoslct'
                                            name="destination_handler"
                                            value={destHandler.find(option => option.value === gridSelect[0]?.destination_handler_id)}
                                            isDisabled
                                        />
                                    </div>
                                    <div>
                                        <Form.Label>Handler Name</Form.Label>
                                        <Select
                                            options={destHandler}
                                            onChange={(selected) => {
                                                setGhaData({ ...ghaData, destination_handler: selected.value })
                                            }}
                                            placeholder="Destination"
                                            className='autoslct'
                                            name="destination_handler"
                                            value={destHandler.find(option => option.value === ghaData.destination_handler)}
                                        />
                                    </div>
                                </Form.Group>
                                <div className='d-flex flex-row bd-highlight inop serv_width'>
                                    {gridSelect && gridSelect.map((num, index) => (
                                        <>
                                            <div key={index} className='inbox d-flex justify-content-between align-items-center'>
                                                <span>{num.uld_number}</span>

                                                <div><img src={Trash} alt='' onClick={() => handleRemove(num.uld_number)} /></div>
                                            </div>
                                        </>
                                    ))}
                                </div>
                            </>
                            : (
                                <>
                                    <div className='d-flex flex-wrap'>
                                        <h3>{responseAction ? responseAction.logic_msg : ''}</h3>
                                        {/* <p>Are you sure you want to continue?</p> */}
                                        <Table striped className='uldlist'>
                                            <thead>
                                                <tr>
                                                    <th>ULD Number</th>
                                                    <th>Flight Number</th>
                                                    <th>Flight Date</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {responseAction && responseAction.ulds.map((value, index) => (
                                                    <tr key={index}>
                                                        <td>{value.uld_number}</td>
                                                        <td>{value.flight_number}</td>
                                                        <td>{value.flight_date}</td>
                                                        <td>{value.uld_status}</td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </Table>
                                        {/* {gridSelect && gridSelect.map((num, index) => (
                                        <div key={index} className='inbox'>
                                            <span>{num.uld_number}</span>
                                            <img src={Trash} alt='' onClick={() => handleRemove(index)} />
                                        </div>
                                    ))}
                                    {selectedRowData && <div className='inbox'><span>{selectedRowData.uld_number}</span></div>} */}
                                    </div>

                                </>
                            )}

                </Modal.Body>
                <Modal.Footer>
                    {/* <Button variant="secondary" onClick={handleCancelChange}> */}
                    {/* {['Repair', 'Lease In', 'Lease Out', 'Condition'].includes(action) ? 'Cancel' : 'No'} */}
                    {/* </Button> */}
                    {action == 'Condition' ? (
                        <>
                            <Button variant="primary" onClick={handleConfirmChange}>
                                Update Status {action}
                            </Button>
                        </>
                    ) : action == 'GHA' ?
                        <Button variant="primary" onClick={processGHA}>
                            Process {action} Transfer
                        </Button>
                        : (
                            <>
                                <div className='d-flex w-50 mx-auto are_bottom'>
                                    <Button variant="secondary" onClick={() => handleActionNoConfirm(responseAction.logic_type)}>
                                        No
                                    </Button>
                                    <Button variant="primary" onClick={() => handleActionConfirm(responseAction.logic_type)}>
                                        Yes
                                    </Button>
                                </div>
                            </>
                        )}
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Operations